<template>
  <div class="store">
    <div>
      <h1 class="text-capitalize-first">{{$t('store')}}</h1>
    </div>
    <div class="tabs header-content">
      <button v-for="type in [PurchasableItemContentType.COINS, PurchasableItemContentType.LOOT_BOX]" :key="type" type="button" @click="state.page = type" class="btn btn-tab" :class="[state.page === type ? 'btn-primary' : '']"><span class="text-capitalize-first">{{ $t(`store_tabs.${type}`) }}</span></button>
    </div>
  </div>

  <div v-if="state.banners.length > 0" class="overflow-auto hidden-scrollbar header-content">
    <div class="d-flex flex-row">
      <template v-for="banner in state.banners" :key="banner.name">
        <welcome v-if="banner.name ==='welcome'" :config="banner.config"></welcome>
      </template>
    </div>
  </div>

  <CoinsStore :coins="coins" v-if="state.page === PurchasableItemContentType.COINS"></CoinsStore>
  <LootboxesStore :lootBoxes="lootBoxed" v-if="state.page === PurchasableItemContentType.LOOT_BOX"></LootboxesStore>
</template>
<style scoped>
.store {
  display: flex;
  flex-direction: column;
  margin: 0 var(--margin-normal);
}

</style>
<script lang="ts" setup>
import {reactive} from "@vue/reactivity";
import BannerDTO from "@/models/BannerDTO";
import {computed, onMounted} from "vue";
import {api} from "@/service/APIClient";
import Welcome from "@/components/banners/Welcome.vue";
import CoinsStore from "@/components/store/CoinsStore.vue";
import {PurchasableItemContentType} from "@/models/enum/PurchasableItemContentType";
import LootboxesStore from "@/components/store/LootboxesStore.vue";
import StoreItemDTO from "@/models/StoreItemDTO";
import {useRoute} from "vue-router";

const route = useRoute()
const resolveTab = (): PurchasableItemContentType => {
  switch (route.params.tab) {
    case 'lootboxes':
      return PurchasableItemContentType.LOOT_BOX;
    default:
      return PurchasableItemContentType.COINS;
  }
}
const state = reactive({
  banners: [] as BannerDTO[],
  page: resolveTab(),
  items: [] as StoreItemDTO[]
});

const coins = computed(() => {
  return state.items.filter(item => item.type === PurchasableItemContentType.COINS)
})

const lootBoxed = computed(() => {
  return state.items.filter(item => item.type === PurchasableItemContentType.LOOT_BOX)
})

onMounted(async () => {
  [state.banners, state.items] = await Promise.all([
    api.call.banners.placement('store'),
    api.call.store.items(),
  ])
})

</script>
